<template>
  <div ref="scrubber" class="image-scrubber">
    <div class="slider-container">
      <Svg360 />
      <!-- <v-slider
        v-if="frames"
        v-model="scrubFrame"
        min="0"
        :max="frames.length"
        height="4px"
        thumb-color="#000"
        track-fill-color="#000"
        track-color="#ccc"
        hide-details
      ></v-slider> -->
    </div>
    <canvas
      ref="canvas"
      :width="`${width}px`"
      :height="`${height}px`"
      @mousedown="onMouseDown"
      @mouseup="mouseDown = false"
      @mousemove="onMouseMove"
      @touchstart="onMouseDown"
      @touchend="mouseDown = false"
      @touchmove.prevent="onMouseMove"
      @mouseleave="mouseDown = false"
      @touchleave="mouseDown = false"
    />
  </div>
</template>

<script>
import { RAF, ElasticNumber } from '@monogrid/js-utils'
import Svg360 from '@/assets/svg/360.svg'

export default {
  name: 'ImageScrubber',
  components: { Svg360 },
  data () {
    return {
      mouseDown: false,
      scrubFrame: 0,
      frames: 0
    }
  },
  props: {
    imageDataArray: {
      type: Array,
      required: false,
      default () { return [] }
    },
    imageArray: {
      type: Array,
      required: false,
      default () { return [] }
    },
    alphaChannelImageArray: {
      type: Array,
      required: false,
      default () { return [] }
    },
    width: {
      required: false,
      type: Number,
      default: 100
    },
    height: {
      required: false,
      type: Number,
      default: 100
    }
  },
  async mounted () {
    this.prevMousePosition = { x: 0, y: 0 }
    this.mousePosition = { x: 0, y: 0 }
    this.playHead = new ElasticNumber(0)
    this.currentFrame = 0
    this.playHead.speed = 3
    this.time = new Date().getTime()
    this.ctx = this.$refs.canvas.getContext('2d')
    RAF.add(this.render)
  },
  destroyed () {
    RAF.remove(this.render)
  },
  watch: {
    imageDataArray: {
      handler () {
        this.forceRender = true
      },
      deep: true
    },
    imageArray: {
      handler () {
        this.forceRender = true
      },
      deep: true
    },
    alphaChannelImageArray: {
      handler () {
        this.forceRender = true
      },
      deep: true
    },
    width: {
      handler () {
        this.forceRender = true
      },
      deep: true
    },
    height: {
      handler () {
        this.forceRender = true
      },
      deep: true
    }
  },
  methods: {
    render () {
      const hasImageArray = (this.imageArray && this.imageArray.length > 0)
      const hasImageDataArray = (this.imageDataArray && this.imageDataArray.length > 0)
      this.frames = hasImageArray ? this.imageArray : hasImageDataArray ? this.imageDataArray : null
      if ((!hasImageArray && !hasImageDataArray) || !frames) return

      const now = new Date().getTime()
      const deltaTime = (now - this.time) / 1000

      const xDelta = this.prevMousePosition.x - this.mousePosition.x
      this.prevMousePosition.x = this.mousePosition.x
      this.prevMousePosition.y = this.mousePosition.y
      if (this.mouseDown) {
        this.$refs.scrubber.style.cursor = 'grabbing'
        this.playHead.target += (xDelta * 0.08)
        this.scrubFrame = this.absmod(Math.floor(this.playHead.value), this.frames.length - 1)
      } else {
        this.$refs.scrubber.style.cursor = 'grab'
      }
      // else if (this.scrubFrame !== this.playHead.target) {
      //   this.playHead.target = this.scrubFrame
      // }

      this.playHead.update(deltaTime)
      // console.log(Math.abs(this.playHead.value - this.playHead.target))
      if (Math.abs(this.playHead.value - this.playHead.target) < 4 && !this.mouseDown) {
        this.playHead.target = this.playHead.value // cut the slow easing to avoid jittering frames
      }

      const prevFrame = this.currentFrame
      this.currentFrame = this.absmod(Math.floor(this.playHead.value), this.frames.length - 1)
      if (prevFrame !== this.currentFrame || this.forceRender) {
        // console.log('render', this.currentFrame)
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)

        if (hasImageDataArray && this.frames[this.currentFrame]) {
          this.ctx.putImageData(this.frames[this.currentFrame], 0, 0)
        }

        if (hasImageArray) {
          if (this.alphaChannelImageArray && this.alphaChannelImageArray[this.currentFrame]) {
            // this.ctx.globalCompositeOperation = 'destination-in'
            this.ctx.drawImage(this.alphaChannelImageArray[this.currentFrame], 0, 0)
            const imageData = this.ctx.getImageData(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)
            for (let i = 0, n = imageData.data.length; i < n; i += 4) {
              imageData.data[i + 3] = imageData.data[i]
            }
            this.ctx.putImageData(imageData, 0, 0)
            this.ctx.globalCompositeOperation = 'source-in'
          }

          if (this.frames[this.currentFrame]) {
            this.ctx.drawImage(this.frames[this.currentFrame], 0, 0)
          }
          this.ctx.globalCompositeOperation = 'source-over'
        }
      }
      this.forceRender = false

      this.time = now
    },
    absmod (n, m) {
      return ((n % m) + m) % m
    },
    getMousePositionX (event, touchIndex = 0) {
      if (event.touches && event.touches.length > 0) {
        return event.touches[touchIndex].pageX
      }
      return event.pageX
    },

    getMousePositionY (event, touchIndex = 0) {
      if (event.touches && event.touches.length > 0) {
        return event.touches[touchIndex].pageY
      }
      return event.pageY
    },

    onMouseMove (e) {
      this.mousePosition.x = this.getMousePositionX(e)
      this.mousePosition.y = this.getMousePositionY(e)
    },
    onMouseDown (e) {
      this.$emit('interaction')
      this.mouseDown = true
      this.onMouseMove(e)
      this.prevMousePosition.x = this.mousePosition.x
      this.prevMousePosition.y = this.mousePosition.y
    }
  }
}
</script>

<style lang="scss" scoped>
.image-scrubber {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
}

canvas {
  height: calc(100% - 50px);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.slider-container {
  width: 50px;
  height: 50px;
  margin: auto;

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: #fff;
    }
  }
}
</style>
